import F370_1 from './images/F370/1.jpg';
import F370_2 from './images/F370/2.jpg';
import F370_3 from './images/F370/3.jpg';
import F370_4 from './images/F370/4.jpg';
import F370_5 from './images/F370/5.jpg';
import F370_6 from './images/F370/6.jpg';
import H350_1 from './images/H350/1.jpg';
import H350_2 from './images/H350/2.jpg';
import H350_3 from './images/H350/3.jpg';
import H350_4 from './images/H350/4.jpg';
import origin1 from './images/OriginOne/1.jpg';
import origin2 from './images/OriginOne/2.jpg';
import origin3 from './images/OriginOne/3.jpg';
import origin4 from './images/OriginOne/4.jpg';
import origin5 from './images/OriginOne/5.jpg';

export const ANIMATION_DIRECTION = {
  BACKWARD: 'fadeInLeft',
  FORWARD: 'fadeInRight',
};

export const Printers = [
  {
    name: 'F123',
    content: [
      {
        title: 'CMM Fixture',
        image: F370_1,
        dimensions: [213, 23, 34],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 123.09,
      },
      {
        title: 'Drill Guide',
        image: F370_2,
        dimensions: [6, 5, 65],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 234.89,
      },
      {
        title: 'End Of Arm Tool',
        image: F370_3,
        dimensions: [23, 45, 78],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 345.78,
      },
      {
        title: 'Metal Forming Guide',
        image: F370_4,
        dimensions: [7, 100, 67],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 456.67,
      },
      {
        title: 'Press Break',
        image: F370_5,
        dimensions: [56, 56, 67],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 567.65,
      },
      {
        title: 'Soft Jaws',
        image: F370_6,
        dimensions: [5, 56, 76],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 678.54,
      },
    ],
  },
  {
    name: 'H350 (SAF)',
    content: [
      {
        title: 'CMM Fixture',
        image: H350_1,
        dimensions: [4, 56, 67],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 23.32,
      },
      {
        title: 'Drill Guide',
        image: H350_2,
        dimensions: [3, 56, 67],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 534.12,
      },
      {
        title: 'End Of Arm Tool',
        image: H350_3,
        dimensions: [2, 56, 78],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 67.76,
      },
      {
        title: 'Metal Forming Guide',
        image: H350_4,
        dimensions: [1, 76, 87],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 67.89,
      },
    ],
  },
  {
    name: 'Origin One (P3)',
    content: [
      {
        title: 'Bike Handlebar Grip',
        image: origin1,
        dimensions: [5, 65, 86],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 23.45,
      },
      {
        title: 'F16 Aircraft Hydraulic Cable Clamp',
        image: origin2,
        dimensions: [234, 456, 87],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 56.78,
      },
      {
        title: 'Respirator Adapter',
        image: origin3,
        dimensions: [2, 67, 78],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 234.56,
      },
      {
        title: 'Robot Leg',
        image: origin4,
        dimensions: [234, 567, 87],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam non',
        volume: 234.67,
      },
      {
        title: 'Scooter Deck',
        image: origin5,
        dimensions: [23, 65, 67],
        info: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna',
        volume: 234.76,
      },
    ],
  },
];
